import React, { useRef } from 'react';
import { IModuleSchema } from '@/api/module';
import { useDrag, useDrop } from 'react-dnd';
import { FaChevronRight, FaFolder } from 'react-icons/fa';
import classNames from 'classnames';

type ItemModuleProps = {
  module: IModuleSchema;
  index: number;
  cardIndex: number;
  onClick: (module: IModuleSchema) => void;
  moveModule: (dragIndex: number, hoverIndex: number) => void;
  isParent: boolean;
};

export const ItemModule: React.FC<ItemModuleProps> = ({
  module,
  index,
  cardIndex,
  onClick,
  moveModule,
  isParent,
}) => {
  const ref = useRef(null);

  const [, drop] = useDrop({
    accept: 'MODULE',
    drop: (item: { module: IModuleSchema; index: number }) => {
      const dragIndex = item.index;
      const hoverIndex = index;

      if (dragIndex === hoverIndex) {
        return;
      }

      moveModule(dragIndex, hoverIndex);
    },
  });

  const [{ isDragging }, drag] = useDrag(
    () => ({
      type: 'MODULE',
      item: { module, index, cardIndex },
      collect: monitor => ({
        isDragging: monitor.isDragging(),
      }),
    }),
    [],
  );

  drag(drop(ref));

  return (
    <button
      ref={ref}
      className={classNames(
        'flex flex-row items-center gap-2.5 p-4 hover:shadow-xl rounded-md bg-white border border-gray-alurkerja-1',
        {
          'opacity-40': isDragging,
          'opacity-100': !isDragging,
        },
        {
          'w-full': isParent,
          'ml-4': !isParent,
        }
      )}
      onClick={() => onClick(module)}
    >
      <FaChevronRight className="w-3 h-3" />
      <FaFolder className="text-blue-400" />
      <span className="flex-grow text-left">{module.module_name}</span>
    </button>
  );
};
